import { ConfigTaskRoles } from '../../plugins/api'

export default {
  namespaced: true,
  state: {
    configTaskRoles: [],
    configTaskRolesByID: {},
  },
  mutations: {
    setConfigTaskRoles(state, configTaskRoles) {
      state.configTaskRoles = configTaskRoles
    },
  },
  actions: {
    async fetchConfigTaskRoles({ commit }, options) {
      try {
        console.log('options', options)
        console.log('commit', commit)
        const listConfig = await ConfigTaskRoles.fetch(options)
        console.log('listConfig', listConfig)
        commit('setConfigTaskRoles', listConfig)
        return listConfig
      } catch (error) {
        console.error('Lấy thông tin cấu hình công việc thất bại!')
        console.error(error)
        return []
      }
    },
    async setConfigTaskRoles({ dispatch }, taskData) {
      try {
        console.log('configTaskRoles', taskData)
        const res_config = await ConfigTaskRoles.create({ ...taskData })
        console.log('res_config', res_config)
        await dispatch('fetchConfigTaskRoles')
        return true
      } catch (error) {
        console.error('Cấu hình role công việc thất bại!')
        console.error(error)
        return false
      }
    },
    async deleteConfigTaskRoles({ dispatch }, id) {
      try {
        const resConfigDelete = await ConfigTaskRoles.remove(id)
        console.log('resConfigDelete', resConfigDelete)
        await dispatch('fetchConfigTaskRoles')
        return true
      } catch (error) {
        console.error('Xóa role công việc thất bại!')
        console.error(error)
        return false
      }
    },
  },
  getters: {
    configs: state => state.configTaskRoles,
  },
}
